import { defineMessages } from 'react-intl';

const sfpMessages = defineMessages({
    sfp: {
        id: 'sfp',
        defaultMessage: 'SFP',
    },
    sfps: {
        id: 'sfps',
        defaultMessage: 'SFPs',
    },
    builtin: {
        id: 'sfp-builtin',
        defaultMessage: 'builtin',
    },
    Builtin: {
        id: 'sfp-builtin-uppercase',
        defaultMessage: 'Builtin',
    },
    empty: {
        id: 'sfp-empty',
        defaultMessage: 'Empty',
    },
    taken: {
        id: 'sfp-taken',
        defaultMessage: 'Taken',
    },
    connected: {
        id: 'sfp-connected',
        defaultMessage: 'Connected',
    },
    disconnected: {
        id: 'sfp-disconnected',
        defaultMessage: 'Disconnected',
    },
    opticalPortsCount: {
        id: 'sfp-opticalPortsCount',
        defaultMessage: 'Optical ports count',
    },
});

export default sfpMessages;
